// src/components/OfflineSyncBanner/OfflineSyncBanner.tsx
// Affiche un bandeau global quand des opérations sont en cours de synchronisation hors ligne.

import React from 'react';
import { Alert, Badge, Space, Typography } from 'antd';
import { CloudSyncOutlined } from '@ant-design/icons';
import { useOfflineSync } from '../../contexts/OfflineSyncContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';

const { Text } = Typography;

const OfflineSyncBanner: React.FC = () => {
  const { t } = useAppTranslation();
  const { pendingCount } = useOfflineSync();

  if (pendingCount <= 0) {
    return null;
  }

  return (
    <Alert
      type="info"
      showIcon
      banner
      message={
        <Space size="small">
          <Badge
            count={pendingCount}
            size="small"
            style={{ backgroundColor: '#1890ff' }}
          >
            <CloudSyncOutlined style={{ fontSize: 16, color: '#1890ff' }} />
          </Badge>
          <Text strong>
            {t('network.offlineSyncTitle')}
          </Text>
          <Text type="secondary">
            {pendingCount === 1
              ? t('network.offlineSyncOne')
              : t('network.offlineSyncMany', { count: pendingCount })}
          </Text>
        </Space>
      }
    />
  );
};

export default OfflineSyncBanner;
